import React from 'react';

import { Grid } from '@material-ui/core';

const ModalHeaderInfo = ({ List = [] }) => (
    <Grid container spacing={2}>
        {List.map(({ name, value, sm = 'auto', md = 'auto', lg = 3, xs = 12 }, indx) => (
            <Grid item xs={xs} sm={sm} md={md} lg={lg} key={indx}>
                <div style={{ textAlign: 'left', width: '100%', fontSize: 12 }}>{name}</div>
                <div style={{ textAlign: 'left', width: '100%', fontSize: 15, fontWeight: 600, padding: '0px' }}> {value || 'N/A'}</div>
            </Grid>
        ))}
    </Grid>
);

export default ModalHeaderInfo;
